import { CommonModule } from '@angular/common';
import { Component, EventEmitter, OnInit, Output, ChangeDetectorRef, ChangeDetectionStrategy, Input } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { LanguagesService } from 'src/app/services/languages/languages.service';
// import { faCheck } from '@fortawesome/free-solid-svg-icons'

@Component({
  selector: 'app-change-language',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './change-language.component.html',
  styleUrls: ['./change-language.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush // ენის დინამიური ცვლილების ოპტიმიზაცია
})
export class ChangeLanguageComponent implements OnInit {

  languages: any[] = []; // ენების სია სერვისიდან
  selectedLanguage: any; // არჩეული ენის ობიექტი

  @Output() LangClose = new EventEmitter<void>(); // მენიუს დახურვა

  faCheck = 'faCheck';

  constructor(
    private translate: TranslateService,
    private languageService: LanguagesService,
    private cdr: ChangeDetectorRef // Angular-ის DetectChanges მექანიზმი
  ) {}

  ngOnInit(): void {
    this.languages = this.languageService.languages; // ენების სია სერვისიდან
    this.languageService.selectedLanguage$.subscribe(language => {
      this.selectedLanguage = language;
      this.translate.use(language.code); // ენის ცვლილება
      this.cdr.markForCheck(); // ცვლილებების შეტყობინება Angular-ს
    });
  }

  // ენის ცვლილების ფუნქცია
  changeLanguage(language: string): void {
    // console.log('Received language:', language); // უნდა იყოს "ka_GE" ან სხვა კოდი
    this.languageService.setSelectedLanguage(language); // პირდაპირ კოდის გადაცემა
  }
  // changeLanguage(language: any): void {
  //   console.log('Received language object:', language); // შევამოწმოთ ენის ობიექტი
  //   if (language && language.code) {
  //     this.languageService.setSelectedLanguage(language.code);
  //   this.LangClose.emit(); // მენიუს დახურვა

  //   } else {
  //     console.error('Language code is undefined:', language); // თუ კოდი undefined არის
  //   }
  // }
}